import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { Router, Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

// Services
import * as srv from '../share/services';

// Interfaces
import { IContact } from '../share/interfaces';

@Injectable()
export class LoginResolver implements Resolve<any> {
    Name = 'LoginResolver';
    constructor(
        private _logSrv: srv.LogService,
        private _userSrv: srv.UserService
    ) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> | any {
        this._logSrv.Debug(this.Name, ['starting']);

        // const guid = route.params['id'];
        try {
            return this._userSrv.getTestContacts();
        } catch (error) {
            'returning'.logWithObject(this.Name, error);
            return undefined;
        }
    }
}



// WEBPACK FOOTER //
// C:/AZURE/ACEP/Acep.Crm.WebPortal/CrmWebPortalGlobal/Membership/AngularApps/PACED/PACEDAngular/src/app/resolvers/login.resolver.ts